import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

    static targets() {
        return ['trigger', 'target'];
    }

    connect() {

        this.targets.findAll('trigger').forEach((trigger) => {
            trigger.addEventListener('click', () => {
                const expanded = trigger.classList.contains('trigger-expanded');

                if (expanded) {
                    trigger.classList.remove('trigger-expanded');
                    this.element.classList.remove('trigger-expanded');
                } else {
                    trigger.classList.add('trigger-expanded');
                    this.element.classList.add('trigger-expanded');
                }

                this.toggleTarget(expanded);
            });
        });

        if (this.element.classList && this.element.classList.contains('trigger-expanded')) {
            this.toggleTarget();
            this.targets.findAll('trigger').forEach((trigger) => {
                trigger.classList.add('trigger-expanded');
            });
        }
    }

    toggleTarget(expanded = false) {
        this.targets.findAll('target').forEach((target) => {
            let totalChildrenHeight = 0;
            if (!expanded) {
                for (const child of target.children) {
                    totalChildrenHeight += child.offsetHeight;
                    const computeStyle = window.getComputedStyle(child);
                    totalChildrenHeight += parseInt(computeStyle.getPropertyValue('margin-top'));
                    totalChildrenHeight += parseInt(computeStyle.getPropertyValue('margin-bottom'));
                }
            }

            target.style.height = `${totalChildrenHeight}px`;

            if (expanded) {
                target.classList.remove('target-expanded');
            } else {
                target.classList.add('target-expanded');
            }
        });
    }
}
